<template>
  <div class="ml_auction_login">
    <div class="ml_auction_title">竞拍管理</div>
    <div class="ml_auction_title_tip">输入密码后可查看详细信息</div>
    <van-field v-model="accessCode" placeholder="请输入密码" class="ml_auction_input" clearable />
    <van-button type="primary" class="ml_auction_btn" @click="submit()">确定</van-button>
  </div>
</template>

<script>
import { auctionLogin } from '@/utils/auction.js'
export default {
  components: {},
  data() {
    return {
      sid: '',
      accessCode: ''
    };
  },
  computed: {},
  mounted() {
    this.sid = this.$route.query.sid
    this.accessCode = localStorage.getItem('_auction_accessCode_') || '' 
  },
  methods: {
    submit() {
      const that = this
      auctionLogin({
        accessCode: that.accessCode,
        sid: that.sid
      }).then(res => {
        localStorage.setItem('_auction_accessCode_', that.accessCode)
        localStorage.setItem("_auction_token_",res.data)
        that.$router.push({
          path: '/auctionmanage',
          query: {
            sid:that.sid
          }
        })
      })
    }
  }
}

</script>
<style lang='scss' scoped>
.ml_auction_login {
  padding: 59px 30px;

  .ml_auction_title {
    line-height: 33px;
    font-family: PingFangSC-Medium;
    font-size: 24px;
    color: #292D33;
    font-weight: 600;
  }

  .ml_auction_title_tip {
    margin-top: 10px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    font-size: 14px;
    color: #979797;
    letter-spacing: 0;
    font-weight: 400;
  }

  .ml_auction_input {
    height: 42px;
    margin-top: 20px;
    background: #F5F7F9;
    border-radius: 21px;
  }

  .ml_auction_btn {
    width: 100%;
    height: 42px;
    margin-top: 25px;
    background: #327FFF;
    border-radius: 25px;
  }
}
</style>